import { SparklesIcon } from "lucide-react";
import type { ReactNode } from "react";

import { BotonDeRellenoConIa } from "./RellenoConIa";

interface BandaDeRellenoConIaProps {
  titulo: string;
  /** Lo que la IA hace con este expediente, en una o dos líneas. */
  children: ReactNode;
  rellenando: boolean;
  disabled: boolean;
  onRellenar: () => void;
}

/**
 * La banda verde con que abren las pestañas de cuadro del rediseño: ícono,
 * qué carga la IA y el botón oscuro «Rellenar con IA».
 *
 * NACIÓ POR EXTRACCIÓN de `PestanaDeConstrucciones` al entrar la segunda
 * pestaña que la dibuja igual (Maquinarias): el verde, el alto y el botón
 * oscuro (superficie que no invierte) son una sola decisión de diseño.
 */
export function BandaDeRellenoConIa({
  titulo,
  children,
  rellenando,
  disabled,
  onRellenar,
}: BandaDeRellenoConIaProps) {
  return (
    <section className="border-success-dot/25 bg-success-soft/50 flex flex-wrap items-center gap-3.5 rounded-xl border-[1.5px] px-4 py-3">
      <span className="bg-success-soft text-success-soft-foreground flex size-8.5 flex-none items-center justify-center rounded-lg">
        <SparklesIcon className="size-4" aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="text-ink text-[0.8125rem] font-bold">{titulo}</h3>
        <p className="text-ink-muted mt-0.5 text-[0.71875rem] font-semibold text-pretty">
          {children}
        </p>
      </div>
      <div className="flex-none">
        <BotonDeRellenoConIa
          rellenando={rellenando}
          disabled={disabled}
          variante="oscura"
          onRellenar={onRellenar}
        />
      </div>
    </section>
  );
}
